export var Theme;
(function (Theme) {
    Theme["Bright"] = "Bright";
    Theme["Dark"] = "Dark";
})(Theme || (Theme = {}));
export var SlideType;
(function (SlideType) {
    SlideType["Match"] = "Match";
    SlideType["Campaign"] = "Campaign";
    SlideType["Creative"] = "Creative";
})(SlideType || (SlideType = {}));
export var Size;
(function (Size) {
    Size["API"] = "API";
    Size["120x240"] = "120x240";
    Size["140x200"] = "140x200";
    Size["120x600"] = "120x600";
    Size["160x600"] = "160x600";
    Size["200x200"] = "200x200";
    Size["280x200"] = "280x200";
    Size["300x250"] = "300x250";
    Size["320x75"] = "320x75";
    Size["320x150"] = "320x150";
    Size["320x160"] = "320x160";
    Size["320x320"] = "320x320";
    Size["320x460"] = "320x460";
    Size["320x480"] = "320x480";
    Size["300x600"] = "300x600";
    Size["375x680"] = "375x680";
    Size["320x50"] = "320x50";
    Size["300x174"] = "300x174";
    Size["320x100"] = "320x100";
    Size["350x120"] = "350x120";
    Size["360x80"] = "360x80";
    Size["360x120"] = "360x120";
    Size["384x50"] = "384x50";
    Size["392x50"] = "392x50";
    Size["360x50"] = "360x50";
    Size["400x600"] = "400x600";
    Size["411x50"] = "411x50";
    Size["450x125"] = "450x125";
    Size["468x60"] = "468x60";
    Size["480x268"] = "480x268";
    Size["600x600"] = "600x600";
    Size["600x1200"] = "600x1200";
    Size["640x100"] = "640x100";
    Size["640x120"] = "640x120";
    Size["640x130"] = "640x130";
    Size["640x150"] = "640x150";
    Size["640x300"] = "640x300";
    Size["640x320"] = "640x320";
    Size["640x1138"] = "640x1138";
    Size["680x100"] = "680x100";
    Size["680x1200"] = "680x1200";
    Size["700x110"] = "700x110";
    Size["728x90"] = "728x90";
    Size["993x90"] = "993x90";
    Size["768x245"] = "768x245";
    Size["800x250"] = "800x250";
    Size["900x150"] = "900x150";
    Size["970x250"] = "970x250";
    Size["970x90"] = "970x90";
    Size["1400x220"] = "1400x220";
    Size["1596x367"] = "1596x367";
    Size["1600x150"] = "1600x150";
    Size["1920x1080"] = "1920x1080";
    Size["540x600"] = "540x600";
})(Size || (Size = {}));
export const VIDEO_SIZES = ['640x1138'];
export var Language;
(function (Language) {
    Language["en"] = "en";
    Language["ie"] = "ie";
    Language["de"] = "de";
    Language["sv"] = "sv";
    Language["es"] = "es";
    Language["pt"] = "pt";
    Language["fr"] = "fr";
    Language["it"] = "it";
    Language["nl"] = "nl";
    Language["fi"] = "fi";
    Language["hi"] = "hi";
    Language["ar"] = "ar";
    Language["be-nl"] = "be-nl";
    Language["fr-be"] = "fr-be";
    Language["fr-ca"] = "fr-ca";
    Language["es-mx"] = "es-mx";
    Language["en-ca"] = "en-ca";
    Language["ca-on"] = "ca-on";
    Language["de-at"] = "de-at";
    Language["en-in"] = "en-in";
})(Language || (Language = {}));
export var Currency;
(function (Currency) {
    Currency["EUR"] = "EUR";
    Currency["CAD"] = "CAD";
    Currency["GBP"] = "GBP";
    Currency["USD"] = "USD";
    Currency["SEK"] = "SEK";
    Currency["MXN"] = "MXN";
    Currency["INR"] = "INR";
    Currency["BRL"] = "BRL";
})(Currency || (Currency = {}));
export var OddsFormat;
(function (OddsFormat) {
    OddsFormat["Decimal"] = "Decimal";
    OddsFormat["Fractional"] = "Fractional";
    OddsFormat["American"] = "American";
    OddsFormat["Winnings"] = "Winnings";
})(OddsFormat || (OddsFormat = {}));
export var License;
(function (License) {
    License["MT"] = "MT";
    License["DE"] = "DE";
    License["CA-ON"] = "CA-ON";
    License["ZA"] = "ZA";
})(License || (License = {}));
export var Template;
(function (Template) {
    Template["MatchBanner"] = "MatchBanner";
    Template["MatchBannerV2"] = "MatchBannerV2";
})(Template || (Template = {}));
export var Country;
(function (Country) {
    Country["AF"] = "AF";
    Country["AL"] = "AL";
    Country["DZ"] = "DZ";
    Country["AS"] = "AS";
    Country["AD"] = "AD";
    Country["AO"] = "AO";
    Country["AI"] = "AI";
    Country["AQ"] = "AQ";
    Country["AG"] = "AG";
    Country["AR"] = "AR";
    Country["AM"] = "AM";
    Country["AW"] = "AW";
    Country["AU"] = "AU";
    Country["AT"] = "AT";
    Country["AZ"] = "AZ";
    Country["BS"] = "BS";
    Country["BH"] = "BH";
    Country["BD"] = "BD";
    Country["BB"] = "BB";
    Country["BY"] = "BY";
    Country["BE"] = "BE";
    Country["BZ"] = "BZ";
    Country["BJ"] = "BJ";
    Country["BM"] = "BM";
    Country["BT"] = "BT";
    Country["BO"] = "BO";
    Country["BQ"] = "BQ";
    Country["BA"] = "BA";
    Country["BW"] = "BW";
    Country["BV"] = "BV";
    Country["BR"] = "BR";
    Country["IO"] = "IO";
    Country["BN"] = "BN";
    Country["BG"] = "BG";
    Country["BF"] = "BF";
    Country["BI"] = "BI";
    Country["CV"] = "CV";
    Country["KH"] = "KH";
    Country["CM"] = "CM";
    Country["CA"] = "CA";
    Country["KY"] = "KY";
    Country["CF"] = "CF";
    Country["TD"] = "TD";
    Country["CL"] = "CL";
    Country["CN"] = "CN";
    Country["CX"] = "CX";
    Country["CC"] = "CC";
    Country["CO"] = "CO";
    Country["KM"] = "KM";
    Country["CD"] = "CD";
    Country["CG"] = "CG";
    Country["CK"] = "CK";
    Country["CR"] = "CR";
    Country["HR"] = "HR";
    Country["CU"] = "CU";
    Country["CW"] = "CW";
    Country["CY"] = "CY";
    Country["CZ"] = "CZ";
    Country["CI"] = "CI";
    Country["DK"] = "DK";
    Country["DJ"] = "DJ";
    Country["DM"] = "DM";
    Country["DO"] = "DO";
    Country["EC"] = "EC";
    Country["EG"] = "EG";
    Country["SV"] = "SV";
    Country["GQ"] = "GQ";
    Country["ER"] = "ER";
    Country["EE"] = "EE";
    Country["SZ"] = "SZ";
    Country["ET"] = "ET";
    Country["FK"] = "FK";
    Country["FO"] = "FO";
    Country["FJ"] = "FJ";
    Country["FI"] = "FI";
    Country["FR"] = "FR";
    Country["GF"] = "GF";
    Country["PF"] = "PF";
    Country["TF"] = "TF";
    Country["GA"] = "GA";
    Country["GM"] = "GM";
    Country["GE"] = "GE";
    Country["DE"] = "DE";
    Country["GH"] = "GH";
    Country["GI"] = "GI";
    Country["GR"] = "GR";
    Country["GL"] = "GL";
    Country["GD"] = "GD";
    Country["GP"] = "GP";
    Country["GU"] = "GU";
    Country["GT"] = "GT";
    Country["GG"] = "GG";
    Country["GN"] = "GN";
    Country["GW"] = "GW";
    Country["GY"] = "GY";
    Country["HT"] = "HT";
    Country["HM"] = "HM";
    Country["VA"] = "VA";
    Country["HN"] = "HN";
    Country["HK"] = "HK";
    Country["HU"] = "HU";
    Country["IS"] = "IS";
    Country["IN"] = "IN";
    Country["ID"] = "ID";
    Country["IR"] = "IR";
    Country["IQ"] = "IQ";
    Country["IE"] = "IE";
    Country["IM"] = "IM";
    Country["IL"] = "IL";
    Country["IT"] = "IT";
    Country["JM"] = "JM";
    Country["JP"] = "JP";
    Country["JE"] = "JE";
    Country["JO"] = "JO";
    Country["KZ"] = "KZ";
    Country["KE"] = "KE";
    Country["KI"] = "KI";
    Country["KP"] = "KP";
    Country["KR"] = "KR";
    Country["KW"] = "KW";
    Country["KG"] = "KG";
    Country["LA"] = "LA";
    Country["LV"] = "LV";
    Country["LB"] = "LB";
    Country["LS"] = "LS";
    Country["LR"] = "LR";
    Country["LY"] = "LY";
    Country["LI"] = "LI";
    Country["LT"] = "LT";
    Country["LU"] = "LU";
    Country["MO"] = "MO";
    Country["MG"] = "MG";
    Country["MW"] = "MW";
    Country["MY"] = "MY";
    Country["MV"] = "MV";
    Country["ML"] = "ML";
    Country["MT"] = "MT";
    Country["MH"] = "MH";
    Country["MQ"] = "MQ";
    Country["MR"] = "MR";
    Country["MU"] = "MU";
    Country["YT"] = "YT";
    Country["MX"] = "MX";
    Country["FM"] = "FM";
    Country["MD"] = "MD";
    Country["MC"] = "MC";
    Country["MN"] = "MN";
    Country["ME"] = "ME";
    Country["MS"] = "MS";
    Country["MA"] = "MA";
    Country["MZ"] = "MZ";
    Country["MM"] = "MM";
    Country["NA"] = "NA";
    Country["NR"] = "NR";
    Country["NP"] = "NP";
    Country["NL"] = "NL";
    Country["NC"] = "NC";
    Country["NZ"] = "NZ";
    Country["NI"] = "NI";
    Country["NE"] = "NE";
    Country["NG"] = "NG";
    Country["NU"] = "NU";
    Country["NF"] = "NF";
    Country["MP"] = "MP";
    Country["NO"] = "NO";
    Country["OM"] = "OM";
    Country["PK"] = "PK";
    Country["PW"] = "PW";
    Country["PS"] = "PS";
    Country["PA"] = "PA";
    Country["PG"] = "PG";
    Country["PY"] = "PY";
    Country["PE"] = "PE";
    Country["PH"] = "PH";
    Country["PN"] = "PN";
    Country["PL"] = "PL";
    Country["PT"] = "PT";
    Country["PR"] = "PR";
    Country["QA"] = "QA";
    Country["MK"] = "MK";
    Country["RO"] = "RO";
    Country["RU"] = "RU";
    Country["RW"] = "RW";
    Country["RE"] = "RE";
    Country["BL"] = "BL";
    Country["SH"] = "SH";
    Country["KN"] = "KN";
    Country["LC"] = "LC";
    Country["MF"] = "MF";
    Country["PM"] = "PM";
    Country["VC"] = "VC";
    Country["WS"] = "WS";
    Country["SM"] = "SM";
    Country["ST"] = "ST";
    Country["SA"] = "SA";
    Country["SN"] = "SN";
    Country["RS"] = "RS";
    Country["SC"] = "SC";
    Country["SL"] = "SL";
    Country["SG"] = "SG";
    Country["SX"] = "SX";
    Country["SK"] = "SK";
    Country["SI"] = "SI";
    Country["SB"] = "SB";
    Country["SO"] = "SO";
    Country["ZA"] = "ZA";
    Country["GS"] = "GS";
    Country["SS"] = "SS";
    Country["ES"] = "ES";
    Country["LK"] = "LK";
    Country["SD"] = "SD";
    Country["SR"] = "SR";
    Country["SJ"] = "SJ";
    Country["SE"] = "SE";
    Country["CH"] = "CH";
    Country["SY"] = "SY";
    Country["TW"] = "TW";
    Country["TJ"] = "TJ";
    Country["TZ"] = "TZ";
    Country["TH"] = "TH";
    Country["TL"] = "TL";
    Country["TG"] = "TG";
    Country["TK"] = "TK";
    Country["TO"] = "TO";
    Country["TT"] = "TT";
    Country["TN"] = "TN";
    Country["TR"] = "TR";
    Country["TM"] = "TM";
    Country["TC"] = "TC";
    Country["TV"] = "TV";
    Country["UG"] = "UG";
    Country["UA"] = "UA";
    Country["AE"] = "AE";
    Country["GB"] = "GB";
    Country["UM"] = "UM";
    Country["US"] = "US";
    Country["UY"] = "UY";
    Country["UZ"] = "UZ";
    Country["VU"] = "VU";
    Country["VE"] = "VE";
    Country["VN"] = "VN";
    Country["VG"] = "VG";
    Country["VI"] = "VI";
    Country["WF"] = "WF";
    Country["EH"] = "EH";
    Country["YE"] = "YE";
    Country["ZM"] = "ZM";
    Country["ZW"] = "ZW";
    Country["AX"] = "AX";
})(Country || (Country = {}));
export const COUNTRY_NAMES = {
    [Country.AF]: 'Afghanistan',
    [Country.AL]: 'Albania',
    [Country.DZ]: 'Algeria',
    [Country.AS]: 'American Samoa',
    [Country.AD]: 'Andorra',
    [Country.AO]: 'Angola',
    [Country.AI]: 'Anguilla',
    [Country.AQ]: 'Antarctica',
    [Country.AG]: 'Antigua and Barbuda',
    [Country.AR]: 'Argentina',
    [Country.AM]: 'Armenia',
    [Country.AW]: 'Aruba',
    [Country.AU]: 'Australia',
    [Country.AT]: 'Austria',
    [Country.AZ]: 'Azerbaijan',
    [Country.BS]: 'Bahamas (the)',
    [Country.BH]: 'Bahrain',
    [Country.BD]: 'Bangladesh',
    [Country.BB]: 'Barbados',
    [Country.BY]: 'Belarus',
    [Country.BE]: 'Belgium',
    [Country.BZ]: 'Belize',
    [Country.BJ]: 'Benin',
    [Country.BM]: 'Bermuda',
    [Country.BT]: 'Bhutan',
    [Country.BO]: 'Bolivia (Plurinational State of)',
    [Country.BQ]: 'Bonaire, Sint Eustatius and Saba',
    [Country.BA]: 'Bosnia and Herzegovina',
    [Country.BW]: 'Botswana',
    [Country.BV]: 'Bouvet Island',
    [Country.BR]: 'Brazil',
    [Country.IO]: 'British Indian Ocean Territory (the)',
    [Country.BN]: 'Brunei Darussalam',
    [Country.BG]: 'Bulgaria',
    [Country.BF]: 'Burkina Faso',
    [Country.BI]: 'Burundi',
    [Country.CV]: 'Cabo Verde',
    [Country.KH]: 'Cambodia',
    [Country.CM]: 'Cameroon',
    [Country.CA]: 'Canada',
    [Country.KY]: 'Cayman Islands (the)',
    [Country.CF]: 'Central African Republic (the)',
    [Country.TD]: 'Chad',
    [Country.CL]: 'Chile',
    [Country.CN]: 'China',
    [Country.CX]: 'Christmas Island',
    [Country.CC]: 'Cocos (Keeling) Islands (the)',
    [Country.CO]: 'Colombia',
    [Country.KM]: 'Comoros (the)',
    [Country.CD]: 'Congo (the Democratic Republic of the)',
    [Country.CG]: 'Congo (the)',
    [Country.CK]: 'Cook Islands (the)',
    [Country.CR]: 'Costa Rica',
    [Country.HR]: 'Croatia',
    [Country.CU]: 'Cuba',
    [Country.CW]: 'Curaçao',
    [Country.CY]: 'Cyprus',
    [Country.CZ]: 'Czechia',
    [Country.CI]: "Côte d'Ivoire",
    [Country.DK]: 'Denmark',
    [Country.DJ]: 'Djibouti',
    [Country.DM]: 'Dominica',
    [Country.DO]: 'Dominican Republic (the)',
    [Country.EC]: 'Ecuador',
    [Country.EG]: 'Egypt',
    [Country.SV]: 'El Salvador',
    [Country.GQ]: 'Equatorial Guinea',
    [Country.ER]: 'Eritrea',
    [Country.EE]: 'Estonia',
    [Country.SZ]: 'Eswatini',
    [Country.ET]: 'Ethiopia',
    [Country.FK]: 'Falkland Islands (the) [Malvinas]',
    [Country.FO]: 'Faroe Islands (the)',
    [Country.FJ]: 'Fiji',
    [Country.FI]: 'Finland',
    [Country.FR]: 'France',
    [Country.GF]: 'French Guiana',
    [Country.PF]: 'French Polynesia',
    [Country.TF]: 'French Southern Territories (the)',
    [Country.GA]: 'Gabon',
    [Country.GM]: 'Gambia (the)',
    [Country.GE]: 'Georgia',
    [Country.DE]: 'Germany',
    [Country.GH]: 'Ghana',
    [Country.GI]: 'Gibraltar',
    [Country.GR]: 'Greece',
    [Country.GL]: 'Greenland',
    [Country.GD]: 'Grenada',
    [Country.GP]: 'Guadeloupe',
    [Country.GU]: 'Guam',
    [Country.GT]: 'Guatemala',
    [Country.GG]: 'Guernsey',
    [Country.GN]: 'Guinea',
    [Country.GW]: 'Guinea-Bissau',
    [Country.GY]: 'Guyana',
    [Country.HT]: 'Haiti',
    [Country.HM]: 'Heard Island and McDonald Islands',
    [Country.VA]: 'Holy See (the)',
    [Country.HN]: 'Honduras',
    [Country.HK]: 'Hong Kong',
    [Country.HU]: 'Hungary',
    [Country.IS]: 'Iceland',
    [Country.IN]: 'India',
    [Country.ID]: 'Indonesia',
    [Country.IR]: 'Iran (Islamic Republic of)',
    [Country.IQ]: 'Iraq',
    [Country.IE]: 'Ireland',
    [Country.IM]: 'Isle of Man',
    [Country.IL]: 'Israel',
    [Country.IT]: 'Italy',
    [Country.JM]: 'Jamaica',
    [Country.JP]: 'Japan',
    [Country.JE]: 'Jersey',
    [Country.JO]: 'Jordan',
    [Country.KZ]: 'Kazakhstan',
    [Country.KE]: 'Kenya',
    [Country.KI]: 'Kiribati',
    [Country.KP]: "Korea (the Democratic People's Republic of)",
    [Country.KR]: 'Korea (the Republic of)',
    [Country.KW]: 'Kuwait',
    [Country.KG]: 'Kyrgyzstan',
    [Country.LA]: "Lao People's Democratic Republic (the)",
    [Country.LV]: 'Latvia',
    [Country.LB]: 'Lebanon',
    [Country.LS]: 'Lesotho',
    [Country.LR]: 'Liberia',
    [Country.LY]: 'Libya',
    [Country.LI]: 'Liechtenstein',
    [Country.LT]: 'Lithuania',
    [Country.LU]: 'Luxembourg',
    [Country.MO]: 'Macao',
    [Country.MG]: 'Madagascar',
    [Country.MW]: 'Malawi',
    [Country.MY]: 'Malaysia',
    [Country.MV]: 'Maldives',
    [Country.ML]: 'Mali',
    [Country.MT]: 'Malta',
    [Country.MH]: 'Marshall Islands (the)',
    [Country.MQ]: 'Martinique',
    [Country.MR]: 'Mauritania',
    [Country.MU]: 'Mauritius',
    [Country.YT]: 'Mayotte',
    [Country.MX]: 'Mexico',
    [Country.FM]: 'Micronesia (Federated States of)',
    [Country.MD]: 'Moldova (the Republic of)',
    [Country.MC]: 'Monaco',
    [Country.MN]: 'Mongolia',
    [Country.ME]: 'Montenegro',
    [Country.MS]: 'Montserrat',
    [Country.MA]: 'Morocco',
    [Country.MZ]: 'Mozambique',
    [Country.MM]: 'Myanmar',
    [Country.NA]: 'Namibia',
    [Country.NR]: 'Nauru',
    [Country.NP]: 'Nepal',
    [Country.NL]: 'Netherlands (the)',
    [Country.NC]: 'New Caledonia',
    [Country.NZ]: 'New Zealand',
    [Country.NI]: 'Nicaragua',
    [Country.NE]: 'Niger (the)',
    [Country.NG]: 'Nigeria',
    [Country.NU]: 'Niue',
    [Country.NF]: 'Norfolk Island',
    [Country.MP]: 'Northern Mariana Islands (the)',
    [Country.NO]: 'Norway',
    [Country.OM]: 'Oman',
    [Country.PK]: 'Pakistan',
    [Country.PW]: 'Palau',
    [Country.PS]: 'Palestine, State of',
    [Country.PA]: 'Panama',
    [Country.PG]: 'Papua New Guinea',
    [Country.PY]: 'Paraguay',
    [Country.PE]: 'Peru',
    [Country.PH]: 'Philippines (the)',
    [Country.PN]: 'Pitcairn',
    [Country.PL]: 'Poland',
    [Country.PT]: 'Portugal',
    [Country.PR]: 'Puerto Rico',
    [Country.QA]: 'Qatar',
    [Country.MK]: 'Republic of North Macedonia',
    [Country.RO]: 'Romania',
    [Country.RU]: 'Russian Federation (the)',
    [Country.RW]: 'Rwanda',
    [Country.RE]: 'Réunion',
    [Country.BL]: 'Saint Barthélemy',
    [Country.SH]: 'Saint Helena, Ascension and Tristan da Cunha',
    [Country.KN]: 'Saint Kitts and Nevis',
    [Country.LC]: 'Saint Lucia',
    [Country.MF]: 'Saint Martin (French part)',
    [Country.PM]: 'Saint Pierre and Miquelon',
    [Country.VC]: 'Saint Vincent and the Grenadines',
    [Country.WS]: 'Samoa',
    [Country.SM]: 'San Marino',
    [Country.ST]: 'Sao Tome and Principe',
    [Country.SA]: 'Saudi Arabia',
    [Country.SN]: 'Senegal',
    [Country.RS]: 'Serbia',
    [Country.SC]: 'Seychelles',
    [Country.SL]: 'Sierra Leone',
    [Country.SG]: 'Singapore',
    [Country.SX]: 'Sint Maarten (Dutch part)',
    [Country.SK]: 'Slovakia',
    [Country.SI]: 'Slovenia',
    [Country.SB]: 'Solomon Islands',
    [Country.SO]: 'Somalia',
    [Country.ZA]: 'South Africa',
    [Country.GS]: 'South Georgia and the South Sandwich Islands',
    [Country.SS]: 'South Sudan',
    [Country.ES]: 'Spain',
    [Country.LK]: 'Sri Lanka',
    [Country.SD]: 'Sudan (the)',
    [Country.SR]: 'Suriname',
    [Country.SJ]: 'Svalbard and Jan Mayen',
    [Country.SE]: 'Sweden',
    [Country.CH]: 'Switzerland',
    [Country.SY]: 'Syrian Arab Republic',
    [Country.TW]: 'Taiwan',
    [Country.TJ]: 'Tajikistan',
    [Country.TZ]: 'Tanzania, United Republic of',
    [Country.TH]: 'Thailand',
    [Country.TL]: 'Timor-Leste',
    [Country.TG]: 'Togo',
    [Country.TK]: 'Tokelau',
    [Country.TO]: 'Tonga',
    [Country.TT]: 'Trinidad and Tobago',
    [Country.TN]: 'Tunisia',
    [Country.TR]: 'Turkey',
    [Country.TM]: 'Turkmenistan',
    [Country.TC]: 'Turks and Caicos Islands (the)',
    [Country.TV]: 'Tuvalu',
    [Country.UG]: 'Uganda',
    [Country.UA]: 'Ukraine',
    [Country.AE]: 'United Arab Emirates (the)',
    [Country.GB]: 'United Kingdom of Great Britain and Northern Ireland (the)',
    [Country.UM]: 'United States Minor Outlying Islands (the)',
    [Country.US]: 'United States of America (the)',
    [Country.UY]: 'Uruguay',
    [Country.UZ]: 'Uzbekistan',
    [Country.VU]: 'Vanuatu',
    [Country.VE]: 'Venezuela (Bolivarian Republic of)',
    [Country.VN]: 'Viet Nam',
    [Country.VG]: 'Virgin Islands (British)',
    [Country.VI]: 'Virgin Islands (U.S.)',
    [Country.WF]: 'Wallis and Futuna',
    [Country.EH]: 'Western Sahara',
    [Country.YE]: 'Yemen',
    [Country.ZM]: 'Zambia',
    [Country.ZW]: 'Zimbabwe',
    [Country.AX]: 'Åland Islands'
};
//# sourceMappingURL=Types.js.map